import { Typography } from "@mui/material";

const UsersPage = () => {
  return <Typography variant="h4">Profil Sayfası</Typography>;
};

export default UsersPage;